import { useState } from 'react';
import { useMutation } from '@apollo/client';
import { RegisterCompanyDocument, SendEmailDocument } from '../../queries';
import { CompanySignUpFormInput } from '../../interfaces/interfaces';
import { logger } from '../../utils/logging';
import {
  COMPANY_SIGNUP_EMAIL_TEMPLATE_ID,
  COMPANY_SIGN_UP_ERROR_MESSAGE,
} from '../../utils/constants';

// Registers the company, then emails the user a link to activate their account
export const useCompanySignUp = () => {
  const [registerCompany] = useMutation(RegisterCompanyDocument);
  const [sendEmail] = useMutation(SendEmailDocument);
  const [isSuccessful, setIsSuccessful] = useState(false);
  const [error, setError] = useState<string>();

  const sendActivateEmail = async (email: string) => {
    const { data } = await sendEmail({
      variables: {
        email,
        emailTemplateId: COMPANY_SIGNUP_EMAIL_TEMPLATE_ID,
        contactProperties: null,
        customProperties: {
          activateLink: `${window.location.origin}/activate?registration=ix-one`,
        },
      },
    });
    return data?.sendEmail === true;
  };

  const signUp = async (values: CompanySignUpFormInput) => {
    logger.info('Company sign up submit', values);
    setError(undefined);

    try {
      const { data } = await registerCompany({ variables: values });
      const isSignedUp =
        !!data?.registerCompany && (await sendActivateEmail(values.email));
      if (isSignedUp) {
        setIsSuccessful(true);
      } else {
        setError(COMPANY_SIGN_UP_ERROR_MESSAGE);
      }
    } catch (err) {
      logger.error(err);
      setError(COMPANY_SIGN_UP_ERROR_MESSAGE);
    }
  };

  return { signUp, isSuccessful, error };
};
